import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "m-4 px-4 sm:px-6 lg:px-8" };
const _hoisted_2 = { class: "sm:flex sm:items-center" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "text-xl font-semibold text-gray-900" }, "Search Results"),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "A list of searched documents")
], -1);
const _hoisted_4 = { class: "mt-4 sm:mt-0 sm:ml-16 sm:flex-none" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "mt-8 flex flex-col md:flex-row justify-end" }, null, -1);
const _hoisted_6 = { class: "mt-8 flex flex-col" };
const _hoisted_7 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" };
const _hoisted_8 = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" };
const _hoisted_9 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_10 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("thead", { class: "bg-gray-50" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        }, "Short ID"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "Role"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "Company Code"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "Hiring Manager"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "Assigned to"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "Current stage")
    ])
], -1);
const _hoisted_12 = {
    key: 0,
    class: "bg-white"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { key: 1 };
const _hoisted_17 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_18 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_19 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_20 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_21 = {
    key: 0,
    class: "text-gray-400 text-center p-8"
};
import { computed, inject, onBeforeMount, onMounted, ref } from 'vue';
import { onBeforeRouteUpdate, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getCompanyCode } from '@/helpers/get-company-code';
import { pathToDocument } from '@/helpers/path-to-document-helper';
import httpClient from '@/httpClient';
import { clearStorage } from '@/storageSave';
export default /*#__PURE__*/ _defineComponent({
    __name: 'searchResults',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const atrs = ref([]);
        const loaded = ref(false);
        const searchString = ref(router.currentRoute.value.params.searchString);
        const docType = ref(router.currentRoute.value.params.docType);
        const stages = inject('stages', []);
        const findStage = (stageName, status) => {
            const foundStage = stages.find((stage) => stage.stageName === stageName);
            if (foundStage)
                return foundStage.displayName;
            return status === 'DRAFT' ? 'Work in progress' : status;
        };
        const currentAssigneeEmail = (atr) => {
            if (atr.currentAssigneeEmail) {
                if (atr.currentAssigneeEmail.includes('@')) {
                    return atr.currentAssigneeEmail;
                }
                if (atr.currentAssignee?.includes('@')) {
                    return atr.currentAssignee;
                }
                return atr.currentAssigneeEmail;
            }
            return 'Unassigned';
        };
        const navigateNewDoc = (docType) => {
            if (docType.toUpperCase() === 'STARTER') {
                clearStorage('atrShortId');
                clearStorage('atrId');
                clearStorage('formData');
            }
            if (docType.toUpperCase() === 'AMEND') {
                clearStorage('amendsFormData');
            }
            if (docType.toUpperCase() === 'LEAVER') {
                store.dispatch('leaverForm/clearAllLeaverFormData');
                clearStorage('leaverShortId');
                clearStorage('leaverForm');
            }
            const routes = {
                starter: '/create-starter/new-atr',
                amend: '/create-amend',
                leaver: '/create-leaver/new-leaver',
            };
            router.push(routes[docType]);
        };
        const navigateToAtr = (atr, docType) => {
            router.push({ path: pathToDocument(atr, docType) });
        };
        const profile = computed(() => store.getters.getProfile);
        const fetchResults = async (docType, searchString) => {
            store.dispatch('setIsLoading', true);
            const response = await httpClient.post('/bff/search', {
                requestedBy: profile.value.email,
                docType,
                docID: searchString,
            });
            atrs.value = response.data.body?.Items ?? [];
            store.dispatch('setIsLoading', false);
        };
        onBeforeRouteUpdate(async (to) => {
            searchString.value = to.params.searchString;
            docType.value = to.params.docType;
            await fetchResults(docType.value, searchString.value);
        });
        onBeforeMount(async () => {
            await fetchResults(docType.value, searchString.value);
        });
        onMounted(() => {
            loaded.value = true;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto ml-2",
                            onClick: _cache[0] || (_cache[0] = ($event) => (navigateNewDoc('amend')))
                        }, "Create Amendment"),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto ml-2",
                            onClick: _cache[1] || (_cache[1] = ($event) => (navigateNewDoc('leaver')))
                        }, "Create Leaver")
                    ])
                ]),
                _createTextVNode(),
                _hoisted_5,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("table", _hoisted_10, [
                                    _hoisted_11,
                                    _createTextVNode(),
                                    (atrs.value.length)
                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(atrs.value, (atr, index) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: atr.docId,
                                                    class: _normalizeClass(index % 2 === 0 ? undefined : 'bg-gray-50')
                                                }, [
                                                    _createElementVNode("td", {
                                                        class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 text-blue-600 hover:underline cursor-pointer",
                                                        onClick: ($event) => (navigateToAtr(atr, atr.docType))
                                                    }, _toDisplayString(atr.shortId), 9, _hoisted_13),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_14, [
                                                        (docType.value === 'OFFER')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(atr.atr?.formThree?.jobTitle ? atr.atr.formThree.jobTitle : 'No role specified'), 1))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(atr.formThree?.jobTitle ? atr.formThree.jobTitle : 'No role specified'), 1))
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(getCompanyCode)(atr)), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_18, _toDisplayString(atr.requestedByEmail), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_19, _toDisplayString(currentAssigneeEmail(atr)), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_20, _toDisplayString(findStage(atr.currentStageName, atr.status)), 1)
                                                ], 2));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                (loaded.value && !atrs.value.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, " No Requests to show... "))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
